import type { FC } from "react"
import AptelIcon from "./AptelIcon"
import MciIcon from "./MciIcon"
import RightelIcon from "./RightelIcon"
import IrancellIcon from "./IrancellIcon"
import ShatelIcon from "./ShatelIcon"
import type { OperatorsName } from "@/stores/operator-store"
import NewMciIcon from "./NewMci"

interface OperatorsIconProps {
    operator: OperatorsName,
    className?: string,
    color?:string,
    operatorColors?: boolean,
    invert?: boolean,
}

const OperatorsIcon:FC<OperatorsIconProps> = ({operator, className, color, operatorColors: isOperatorColor, invert}) => {

    const operatorColors = {
        irancell: 'fill-irancell-primary',
        rightel: 'fill-rightel-primary',
        mci: 'fill-mci-primary',
        shatel: 'fill-shatel-primary',
        aptel: 'fill-aptel-primary',
        'td-lte': 'fill-irancell-primary',
      }
    
      const operatorColorsInvert = {
        irancell: 'fill-irancell-secondary',
        rightel: 'fill-rightel-secondary',
        mci: 'fill-mci-secondary',
        shatel: 'fill-shatel-secondary',
        aptel: 'fill-aptel-secondary',
        'td-lte': 'fill-irancell-secondary',
      }

    const colors = color ? color : isOperatorColor ? invert ? operatorColorsInvert[operator] : operatorColors[operator] : 'fill-black dark:fill-white'
    const props = {
        color: colors,
        className,
    }
    switch(operator.toLowerCase()) {
        case 'mci':
            return <NewMciIcon {...props} />
        case 'irancell':
            return <IrancellIcon {...props}/>
        case 'td-lte': 
            return <IrancellIcon {...props}/>
        case 'rightel': 
            return <RightelIcon {...props}/>
        case 'aptel':
            return <AptelIcon {...props} />
        case 'shatel':
            return <ShatelIcon {...props} />
        default:
            return <></>    
    }
}

export default OperatorsIcon